import type { App } from "vue";
import { MotionPlugin } from "@vueuse/motion";

export default {
  install(app: App) {
    app.use(MotionPlugin);
  },
};
